import { createAction, props } from '@ngrx/store';
import type { PostHomebatteryV1Data } from '@integration/api-client/feh';
import type { ScLinkField } from '@core/jss-models';

const prefix = '[Homebattery Advice]';

export const submitHomebatteryAdviceForm = createAction(
  `${prefix} Submit form`,
  props<{
    payload: PostHomebatteryV1Data;
  }>()
);

export const setRedirectUrl = createAction(
  `${prefix} Set redirect url`,
  props<{
    redirectUrl: ScLinkField;
  }>()
);
